import PropTypes from 'prop-types';

export const ProductGridPropTypes = {
    Products: PropTypes.arrayOf(PropTypes.shape({
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    })).isRequired,
};

export const ProjectGridPropTypes = {
    projects: PropTypes.arrayOf(PropTypes.shape({
        image: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        autor: PropTypes.string.isRequired
    })).isRequired,
};

export const PaginationPropTypes = {
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};